// extracted by mini-css-extract-plugin
export default {"additionalPoint":"index_additionalPoint__8xDq8"};